/* eslint-disable react-hooks/exhaustive-deps */
import DataGridColumn from "./DataGridColumn";
import { FlexGridCellTemplate } from "@grapecity/wijmo.react.grid";
import { useEffect, useState } from "react";

import format from 'format-number';


// Form Item Type Select에 대응하는 Custom DataGridColumn

function DataGridRatioColumn ( props ) {

    const { schema, ...others } = props;

    const [ cellTemplate, setCellTemplate ] = useState ( ( ctx ) => {
        return <></>;
    } );


    useEffect ( () => {

        setCellTemplate ( () => ( ( ctx ) => {

            return (
                <>
                    <span>{ format ( { round: 2, suffix: "%"  } )( ctx.item[schema.name] ) }</span>
                </>
            );

        } ) );

    }, [schema] );

    return (

        <DataGridColumn schema={schema} {...others} >
            <FlexGridCellTemplate cellType="Cell" template={cellTemplate} />
        </DataGridColumn>

    );

}

export default DataGridRatioColumn;

